export const colors = {
  purple: "#d8b4fe",
  orange: "#fdba74",
  blue: "#93c5fd",
  cyan: "#67e8f9",
  primary: "#72d4c4",
  green: "#22c55e",
};
